import React from 'react';
import { Hero } from '../components';

const HomePage = () => {
	return <Hero></Hero>;
};

export default HomePage;
